import React from 'react';
import * as Render from '../platformui/Base/Render';
import HighLight from '../platformui/HighLight';
export default (props) => (
  <HighLight
    {...props}
    Heading={Render.Property(props.Heading, 'Heading')}
    ContentString={Render.PropertyAsHTML(props.ContentString, 'Content')}
    RegionalContent={props.RegionalContent}
  />
);
